module.exports = __webpack_public_path__ + "static/media/sign-up.bf867aab.PNG";